// removed by extract-text-webpack-plugin
module.exports = {"document":"_33ISceKY1Q4JVje0Jw-c7B","image":"In-eIbwnjeM71ouKMFz7w","content":"_3uDr812LkerGW9Fkz9lyEC","links":"_1eIdGEoiJWDZgmwHZxhpHm","title":"_3LNDiHJ70Ei4sD9w8ZEmsa","pdf":"_3L4MlTnKSQdDtrlqMCBXof"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentBlock/DocumentBlock.module.scss
// module id = 750
// module chunks = 0